import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Payment from './components/payment';
import PaymentComplete from './components/paymentcomplete';

function App ()  {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="*" element={<Payment />} />
          <Route path="/payment-complete" element={<PaymentComplete />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
